module.exports = __webpack_public_path__ + "img/tree_10002.4d97519c.png";